import {HttpClient} from '@angular/common/http';
import {Observable} from "rxjs";
import {Token} from "../../../models/token";
import {Router} from "@angular/router";
	

export class AbstractRESTService {

    constructor(public http: HttpClient,
                public baseUrl: string,
                public router: Router) {
    }

    get(url: string, opts?: any): Observable<any> {
        return this.http.get(this.baseUrl + url, opts);
    }

    post(url: string, data, opts?: any): Observable<any> {
        return this.postRaw(url, data, opts);
    }

    postRaw(url: string, data, opts?: any): Observable<any> {
        return this.http.post(this.baseUrl + url, data, opts);
    }

    put(url: string, data): Observable<any> {
        return this.http.put(this.baseUrl + url, data);
    }

    delete(url: string, opts?: any): Observable<any> {
        return this.http.delete(this.baseUrl + url, opts);
    }

}